import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { fetchPosLocationOptions } from '../../sagas/routines';

const initialState = {
  location: {
    options: [],
    fetching: false,
    fetched: false,
    fetchingError: false
  }
};

const fetchHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    location: {
      ...state.location,
      fetching: true,
      fetched: false
    }
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('location.options', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    location: {
      ...state.location,
      fetching: false,
      fetched: true
    }
  })
});

export default createReducer(initialState, {
  ...fetchHandler(fetchPosLocationOptions)
});
